import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
`;

export const Row = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
`;
